type LoyaltyPointsAggregate = {
  aggregate?: {
    sum?: {
      points?: number | null;
    } | null;
  } | null;
};

type UserWithLoyaltyPoints = {
  points?: number | null;
  loyaltyPointsAggregate?: LoyaltyPointsAggregate | null;
  loyalty_point_transactions_aggregate?: LoyaltyPointsAggregate | null;
};

function readAggregatePoints(
  aggregate?: LoyaltyPointsAggregate | null,
): number | null {
  const points = aggregate?.aggregate?.sum?.points;

  if (points === null || points === undefined) {
    return null;
  }

  return Math.max(0, Math.floor(points));
}

/** Prefer ledger aggregate sum; fall back to cached user.points. */
export function resolveLoyaltyPointsBalance(
  user: UserWithLoyaltyPoints | null | undefined,
): number {
  if (!user) {
    return 0;
  }

  const ledgerBalance =
    readAggregatePoints(user.loyaltyPointsAggregate) ??
    readAggregatePoints(user.loyalty_point_transactions_aggregate);

  if (ledgerBalance !== null) {
    return ledgerBalance;
  }

  return Math.max(0, Math.floor(user.points ?? 0));
}

export function withResolvedLoyaltyPoints<T extends UserWithLoyaltyPoints>(
  user: T | null | undefined,
): T | null | undefined {
  if (!user) {
    return user;
  }

  return {
    ...user,
    points: resolveLoyaltyPointsBalance(user),
  };
}
